import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import type { BotAvatarSet } from "@rakazo/contracts";
import { BOT_COLORS, parseBotAvatarValue, WAFI_AVATAR } from "@rakazo/contracts";
import { BotAvatar, Dialog, DialogContent, DialogHeader, DialogTitle } from "@rakazo/ui-web";
import { useState } from "react";

function isLookSelected(value: string, option: string): boolean {
  if (value === WAFI_AVATAR || option === WAFI_AVATAR) return value === option;
  const parsed = parseBotAvatarValue(value);
  return "color" in parsed && parsed.color.toLowerCase() === option.toLowerCase();
}

export function BotLookPicker({
  value,
  onChange,
}: {
  value: string;
  identity?: string;
  organicIdentities?: readonly string[];
  avatarSet?: BotAvatarSet;
  onAvatarSetChange?: (set: BotAvatarSet, value: string) => void;
  onChange: (value: string, identity?: string) => void;
}) {
  return (
    <div className="grid grid-cols-6 place-items-center gap-2">
      {[WAFI_AVATAR, ...BOT_COLORS].map((color, index) => (
        <button
          key={color}
          type="button"
          aria-label={index === 0 ? t`Default` : t`Color ${color}`}
          aria-pressed={isLookSelected(value, color)}
          onClick={() => onChange(color)}
          className="rounded-lg p-1 aria-pressed:ring-2 ring-foreground"
        >
          <BotAvatar color={color} size={32} />
        </button>
      ))}
    </div>
  );
}
export interface AvatarStudioPopoverProps {
  value: string;
  identity?: string;
  status?: string;
  avatarSet?: BotAvatarSet;
  size?: number;
  onChange: (value: string, avatarSet?: BotAvatarSet) => void;
  disabled?: boolean;
}
export function AvatarStudioPopover({
  value,
  identity,
  status,
  avatarSet,
  size = 72,
  onChange,
  disabled = false,
}: AvatarStudioPopoverProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen(true)}
        aria-label={t`Customize Wafi avatar`}
        data-testid="avatar-studio-trigger"
      >
        <BotAvatar
          color={value}
          identity={identity}
          size={size}
          status={status}
          avatarSet={avatarSet}
        />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="w-[360px] max-w-full"
          data-testid="avatar-studio"
          aria-describedby={undefined}
        >
          <DialogHeader>
            <DialogTitle>
              <Trans>Avatar Studio</Trans>
            </DialogTitle>
          </DialogHeader>
          <BotLookPicker value={value} identity={identity} onChange={(next) => onChange(next)} />
        </DialogContent>
      </Dialog>
    </>
  );
}
